import { cn } from '@/lib/utils';
import { ButtonHTMLAttributes, forwardRef } from 'react';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant = 'default', size = 'md', ...props }, ref) => {
    return (
      <button
        className={cn(
          'inline-flex items-center justify-center rounded-full font-medium transition-colors',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2',
          'disabled:pointer-events-none disabled:opacity-50',
          {
            'bg-brand-primary text-white hover:bg-brand-light dark:bg-brand-primary dark:hover:bg-brand-light': variant === 'default',
            'border-2 border-brand-primary bg-white hover:bg-brand-50 text-brand-primary dark:border-brand-primary dark:bg-gray-800 dark:text-brand-light dark:hover:bg-gray-700': variant === 'outline',
            'hover:bg-brand-50 text-brand-primary dark:text-brand-light dark:hover:bg-gray-800': variant === 'ghost',
            'h-9 px-4 text-sm': size === 'sm',
            'h-12 px-6': size === 'md',
            'h-14 px-8 text-lg': size === 'lg',
          },
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);

Button.displayName = 'Button';

export { Button };